import { api } from "../../api/api";
import { IAuthContextState } from "../../contexts/AuthProvider";
import { IJobCustomer } from "../../redux/job_customer";

import { getBillingCompanyFromStorage } from "./BillingCompanyProvider.storage";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";

export const fetchBillingCompanyInfoAsync = (
  affiliated_billing_company_uuids: IAuthContextState["userInfo"]["user"]["affiliated_billing_company_uuids"],
) =>
  new Promise<IBillingCompanyContextState | null>(async (resolve, reject) => {
    let selected_billing_company_uuid = null;
    if (affiliated_billing_company_uuids?.length > 0) {
      const currentComapnyInfo = getBillingCompanyFromStorage();
      const hasValidComapny = affiliated_billing_company_uuids.find(
        (company) =>
          company.billing_company_uuid === currentComapnyInfo.customer_uuid,
      );
      if (hasValidComapny) {
        selected_billing_company_uuid = hasValidComapny.billing_company_uuid;
      } else {
        selected_billing_company_uuid =
          affiliated_billing_company_uuids[0].billing_company_uuid;
      }
    }

    if (!selected_billing_company_uuid) {
      return resolve(null);
    }

    const companyRes = await api.get(
      `/customer/get-customer?customer_uuid=${selected_billing_company_uuid}`,
    );

    const comapnyInfo = companyRes.data.data as IJobCustomer[];
    console.log("companyRes ==>", comapnyInfo);
    resolve({ comapny: comapnyInfo[0] });
  });
